// src/components/ViewfinderFrame.jsx
// Moldura com "cantos de mira" inspirada no visor de um drone.
// Usada no hero e nos cards do portfólio como elemento de identidade visual.
import "./ViewfinderFrame.css";

function ViewfinderFrame({ tag, children, className = "" }) {
  return (
    <div className={`viewfinder ${className}`}>
      <span className="vf-corner vf-corner--tl" />
      <span className="vf-corner vf-corner--tr" />
      <span className="vf-corner vf-corner--bl" />
      <span className="vf-corner vf-corner--br" />
      {tag && <span className="vf-tag">{tag}</span>}
      {children}
    </div>
  );
}

export default ViewfinderFrame;
